var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Box',[_c('v-layout',{style:({ 'min-height': (_vm.minHeight + "px") }),attrs:{"fill-height":"","align-center":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }